export default "__VITE_ASSET__CNPUoXBq__"